var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipInfoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Youth-Camp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Youth-Camp-|-State-2-(Desktop)",
    transform: "translate(-246.000000, -268.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TooltipInfo_White",
    transform: "translate(246.000000, 268.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 C9.31373347,0 12,2.68626671 12,6 C12,9.31373347 9.31373347,12 6,12 C2.68626671,12 0,9.31373347 0,6 C0,2.68626671 2.68626671,0 6,0 Z M6.00000009,0.666666677 C3.05920005,0.666666677 0.666666677,3.05920005 0.666666677,6.00000009 C0.666666677,8.94080013 3.05920005,11.3333335 6.00000009,11.3333335 C8.94080013,11.3333335 11.3333335,8.94080013 11.3333335,6.00000009 C11.3333335,3.05920005 8.94080013,0.666666677 6.00000009,0.666666677 Z M6.60973343,4.5053334 L6.60973343,8.81613346 L7.28133344,8.81613346 L7.28133344,9.53653348 L4.71866674,9.53653348 L4.71866674,8.81613346 L5.39013341,8.81613346 L5.39013341,5.22573341 L4.71866674,5.22573341 L4.71866674,4.5053334 L6.60973343,4.5053334 Z M5.98640009,2.4634667 C6.22413343,2.4634667 6.41706676,2.5262667 6.55946676,2.65053337 C6.70733343,2.77933337 6.78226677,2.95373338 6.78226677,3.16853338 C6.78226677,3.38360005 6.7072001,3.55786672 6.55933343,3.68666672 C6.4172001,3.81066672 6.22440009,3.87360006 5.98640009,3.87360006 C5.76160009,3.87360006 5.57253342,3.81133339 5.42480008,3.68853339 C5.26946675,3.56000005 5.19066674,3.38493338 5.19066674,3.16853338 C5.19066674,2.95226671 5.26933341,2.77746671 5.42480008,2.64853337 C5.57280008,2.52573337 5.76173342,2.4634667 5.98640009,2.4634667 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipInfoWhite);
export default __webpack_public_path__ + "static/media/tooltip-info-white.3672b1cdc0eb5c4ea2f850deff0af679.svg";
export { ForwardRef as ReactComponent };